import { render, staticRenderFns } from "./DoctorSkeletonLoader.vue?vue&type=template&id=0bdec6e6"
import script from "./DoctorSkeletonLoader.vue?vue&type=script&lang=js"
export * from "./DoctorSkeletonLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports